import { STRIPE_HTTP_STATUS_CODES } from "@/types/stripe";
import { Leaves } from "@/types/UtilTypes";
import { TRPC_ERROR_CODE_KEY } from "@trpc/server";

export const ProductIDs = {
  AdPartner: "prod_RacZlIDHQqn6yB",
  BpNewsletter: "prod_V5xPFrThLxCLQP",
  Busrequest: "prod_VM2gGDWALkgE70",
} as const satisfies Record<string, `prod_${string}`>;

export type ProductIDs = keyof typeof ProductIDs;

export type SubscriptionProductIDs = Extract<ProductIDs, "AdPartner">;

export type SinglePaymentProductIDs = Exclude<ProductIDs, "AdPartner">;

export type PriceOptions<T extends ProductIDs> = {
  AdPartner: "Yearly" | "SixMonthly" | "Monthly";
  BpNewsletter: "AdvertiserPrice" | "BuspartnerPrice";
  Busrequest: "AdvertiserPrice" | "BuspartnerPrice" | "GuestPrice";
}[T];

export const PriceIDs = {
  AdPartner: {
    Yearly: "price_1ShZhWGjbvsJjPaRnv8ZC3Vr",
    SixMonthly: "price_1ShZfuGjbvsJjPaRvECGBzEq",
    Monthly: "price_1ShZf3GjbvsJjPaRuDLfqzKS",
  },
  BpNewsletter: {
    AdvertiserPrice: "price_1U5lUHGjbvsJjPaR75iCNjtc",
    BuspartnerPrice: "price_1U5lUHGjbvsJjPaRcXVehHNG",
  },
  Busrequest: {
    GuestPrice: "price_1UQnCSGjbvsJjPaRXDKUOF0j",
    AdvertiserPrice: "price_1ULKaqGjbvsJjPaRFLr7BnOO",
    BuspartnerPrice: "price_1ULKarGjbvsJjPaRzUcL1nSM",
  },
} as const satisfies {
  [K in ProductIDs]: Record<PriceOptions<K>, `price_${string}`>;
};

export type PriceIDs<T extends ProductIDs> =
  (typeof PriceIDs)[T][keyof (typeof PriceIDs)[T]];

export type SubscriptionPriceIDs = PriceIDs<Extract<ProductIDs, "AdPartner">>;

type PriceIDsForProducts<T extends ProductIDs> = T extends ProductIDs
  ? PriceIDs<T>
  : never;

export type SinglePaymentPriceIDs =
  PriceIDsForProducts<SinglePaymentProductIDs>;

export const STRIPE_CUSTOMER_PORTAL_ID =
  "bpc_1ShZ6xGjbvsJjPaRAtFwcF3H" satisfies `bpc_${string}`;

// The length of the trial period in days
export const TRIAL_PERIOD_DAYS = 30 satisfies number | undefined;

export const TRIAL_PERIODS = {
  "AdPartner.Monthly": TRIAL_PERIOD_DAYS,
  "AdPartner.SixMonthly": TRIAL_PERIOD_DAYS,
  "AdPartner.Yearly": TRIAL_PERIOD_DAYS,
} as const satisfies Record<
  Leaves<Extract<typeof PriceIDs, "AdPartner">>,
  number | undefined
>;

export const STRIPE_TO_TRPC_STATUS = {
  400: "BAD_REQUEST",
  401: "UNAUTHORIZED",
  402: "INTERNAL_SERVER_ERROR",
  403: "FORBIDDEN",
  404: "NOT_FOUND",
  409: "CONFLICT",
  424: "INTERNAL_SERVER_ERROR",
  429: "TOO_MANY_REQUESTS",
  500: "INTERNAL_SERVER_ERROR",
  502: "BAD_GATEWAY",
  503: "SERVICE_UNAVAILABLE",
  504: "GATEWAY_TIMEOUT",
} as const satisfies Record<
  Exclude<STRIPE_HTTP_STATUS_CODES, 200>,
  TRPC_ERROR_CODE_KEY
>;
